import { useState } from "react";

import "./FloatingActionMenu.css"; // Custom CSS for animations


function FloatingActionMenu() {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 999 }}>
     

          {/* WhatsApp */}
          <div className="d-flex align-items-center gap-2 pulse-button whatsappButton">
            
            <a href="https://wa.me/255784994151" target="_blank" className="btn btn-success rounded-circle d-flex align-items-center justify-content-center whatsappButton" style={{ width: "50px", height: "50px" }}>
              <i className="bi bi-whatsapp fs-5"></i>
            </a>
          </div>
          </div>

        
  );
}

export default FloatingActionMenu;
